/**
 * PilotHintText component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled pilot hint text.
 */
const PilotHintText = styled.span`
  color: ${Colors['text']};
  font-family: ${Fonts['light']};
  font-size: ${32 * Screen.widthRatio}px;
  left: 0;
  text-align: center;
  top: 0;
`;

export default PilotHintText;
